import React from "react";

import { useSearchspringSearchContext } from "@app/providers/searchspring";

import { ResultSort } from "@app/components/result-sort";
import { ResultFilterDrawer } from "@app/components/result-filter-drawer";
import { ResultActiveFilter } from "@app/components/result-active-filters";

export function ResultControls() {
  const { response } = useSearchspringSearchContext();
  if (!response) return null;
  return (
    <div className="flex flex-col gap-4 p-4 md:px-12 md:py-6">
      <div className="flex justify-between">
        <div className="flex items-center gap-4">
          <ResultFilterDrawer />
          <ResultActiveFilter className="max-md:hidden" />
        </div>
        <div className="flex items-center gap-4">
          <p className="sh1 whitespace-nowrap text-neutrals-grey-2">{response.pagination.totalResults} result(s)</p>
          <div className="max-md:hidden">
            <ResultSort />
          </div>
        </div>
      </div>
      <ResultActiveFilter className="md:hidden" />
    </div>
  );
}
